import {z} from 'zod';

// f=c_dist_hiper&d=2&r=&p=false&filter=true&c_min=0&c_max=58570
export const QuantileRequestSchema = z.object({
    f: z.string(),
    d: z.number(),
    r: z.string(),
    p: z.boolean(),
    filter: z.boolean(),
    c_min: z.number(),
    c_max: z.number(),
});
export interface QuantileRequestType extends z.infer<typeof QuantileRequestSchema> { }


// {"status":"ok","v":[2740],"v_min":"0","v_max":"65137"}
export const QuantileResponseTypeSchema = z.object({
    status: z.literal('ok'),
    v_min: z.coerce.number(), // "0" -> 0
    v_max: z.coerce.number(), // "65137" -> 65137
    v: z.array(z.number()),
});
export interface QuantileResponseType extends z.infer<typeof QuantileResponseTypeSchema> { }


export class featureQuantile {

    public static async getQuantile(request: QuantileRequestType): Promise<QuantileResponseType> {
        return new Promise((resolve, reject) => {
            try {
                QuantileRequestSchema.parse(request);
            } catch (error) {
                console.debug('getQuantile, request', request);
                console.error(`ZodError, ${error.message}`);
                reject(`Błąd na wejściu danych (getQuantile): ${error.message}`);
            }
            console.debug('getQuantile, request', request);
            fetch('./index.php?action=rpc_quantile', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: featureQuantile.convertRequestToURLSearchParams(request)
            }).then((response) => {
                return response.json();
            }).then((data: QuantileResponseType) => {
                console.log('data', data);
                try {
                    QuantileResponseTypeSchema.parse(data);
                } catch (error) {
                    console.debug('getQuantile, response', data);
                    console.error(`ZodError, ${error.message}`);
                    reject(`Błąd zod: ${error.message}`);
                }
                if (data.status !== 'ok') {
                    reject('Nie udało się pobrać danych z serwera. Spróbuj ponownie później');
                } else {
                    resolve(data);
                }
            }).catch((error) => {
                reject('Błąd: ' + error);
            });
        });
    }

    private static convertRequestToString(request: QuantileRequestType): {[key:string]: string} {
        // convert all values from request to string and save as new object
        let requestConvertedToString: { [key:string]: string} = {};
        Object.keys(request).forEach((key) => {
            requestConvertedToString[key] = request[key].toString();
        });
        return requestConvertedToString;
    }

    private static convertRequestToURLSearchParams(request: QuantileRequestType): string {
        return new URLSearchParams(featureQuantile.convertRequestToString(request)).toString();
    }
}